import React from "react";
// import { cdImg } from "../../../assets/mediaCall";

const AboutUs = () => {
  return (
    <div>
      <div className='w-[90%] mx-auto my-[5%]'>
        <h1 className="font-bold text-[60px] text-center mb-8 gradient-text
  xl:text-[50px] lg:text-[45px] md:text-[40px] sm:text-[35px] xs:text-[30px] oswald">Our Team</h1>
        
        
        <div>
          <p  className='flex justify-center items-center montserrat text-zinc-500 text-justify'>
          At Codewolfers, our strength lies in our exceptional team of skilled professionals. United by a shared passion for technology and innovation, we are a diverse group of experts whose combined experience spans various domains. This allows us to deliver comprehensive software solutions tailored to meet the unique needs of each client. We pride ourselves on our collaborative approach, ensuring that every project benefits from the collective knowledge and creativity of our team. Together, we strive to exceed expectations, driving success through our commitment to quality, integrity, and excellence.
          </p>
        </div>
       
      </div>
    </div>
  );
};

export default AboutUs;

// Image Type: A group photo of your team, or a creative office environment
